// extracted by mini-css-extract-plugin
export default {"authForm":"signupForm_authForm__t8L94","nameWrapper":"signupForm_nameWrapper__elKS2","extraWrapper":"signupForm_extraWrapper__NB2fp"};